import { Component, Input } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { ModuleGuideModalComponent } from '@modals/module-guide/module-guide.component';

export interface IModuleGuideItem {
    /** ionicon name */
    icon: string;
    title: string;
    text: string;
}

/**
 * Button that opens a modal with a short guide about the purpose of a module.
 * Place it in a toolbar `ion-buttons`.
 *
 * <module-guide title="Sobre a newsletter" description="..." [items]="[{ icon: 'eye-outline', title: '...', text: '...' }]">
 */
@Component({
    selector: 'module-guide',
    templateUrl: './module-guide.component.html',
    styleUrls: ['./module-guide.component.scss'],
})
export class ModuleGuideComponent {

    @Input() title: string = 'Sobre este módulo';
    @Input() description: string = '';
    @Input() items: IModuleGuideItem[] = [];

    constructor(private ModalController: ModalController) { }

    async OnOpen() {

        const modal = await this.ModalController.create({
            component: ModuleGuideModalComponent,
            componentProps: { headerTitle: this.title, description: this.description, items: this.items },
            cssClass: 'default small'
        });

        await modal.present();
    }
}
